<template>
    <ChatbotDashboard
        v-if="isReady"
        :board="board(storyId)"
        :storyId="storyId"
        :storyVersion="storyVersion"
        :story-title="$_.get(getStoryById(storyId), 'title')"
    />
    <CbDashboardProgressBar v-else :isReady="isReady" />
</template>

<script>
import ChatbotDashboard from "./diagram/ChatbotDashboard";
import log2 from "../../../../../utils/log2";
import { mapGetters, mapActions, mapState, mapMutations } from "vuex";
import CbDashboardProgressBar from "./common/CbDashboardProgressBar";
import Vue from "vue";
import VAnimateCss from "v-animate-css";

Vue.use(VAnimateCss);
const log = log2("ChatbotPage");

export default {
    name: "ChatbotPage",
    components: {
        ChatbotDashboard,
        CbDashboardProgressBar,
    },
    computed: {
        ...mapGetters({
            board: "CB/board",
            getStoryById: "CB/getStoryById",
        }),
        ...mapState({
            storyVersion: (state) => state.CB.selectedBoard,
        }),
    },
    methods: {
        ...mapActions({
            getStory: "CB/getStory",
        }),
        ...mapMutations({
            switchVersion: "CB/CHANGE_BOARD",
        }),
    },
    data() {
        return {
            storyId: window.location.pathname.split("/")[3],
            isReady: false,
        };
    },
    beforeMount() {
        this.switchVersion(this.$route.params.version);
    },
    mounted() {
        log("mounted");
        const boardExists = this.board(this.storyId);
        if (boardExists) {
            setTimeout(() => {
                this.isReady = true;
            }, 1000);
        } else {
            const startTS = Date.now();
            this.getStory({
                id: this.storyId,
                version: this.storyVersion,
            }).then(() => {
                const tookTime = Date.now() - startTS;
                if (tookTime < 1000) {
                    setTimeout(() => {
                        this.isReady = true;
                    }, 1000 - tookTime);
                } else {
                    this.isReady = true;
                }
            });
        }
    },
};
</script>

<style lang="scss">
.ant-popover.no-padding {
    .ant-popover-inner-content {
        padding: 0 !important;
    }
}
</style>
